module.exports = __webpack_public_path__ + "static/img/63fe7f63407b132f62df903181427ed8.8815d0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/63fe7f63407b132f62df903181427ed8.jpg
// module id = +T/8
// module chunks = 3